import React from "react";
import {isTrimmedStringEmpty} from "../../Utilities/commonUtilities";
import UserIcon from "../../images/User-Icon.svg";

interface ProfileButtonProps {
    disabled?: boolean;
    label: string;
    name: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    aria_controls?: string;
}

export const ProfileButton = ({disabled, label, name, onClick, aria_controls}: ProfileButtonProps) => {
    if (isTrimmedStringEmpty(label)) return null;
    return (
        <button
            aria-controls={aria_controls}
            aria-haspopup="true"
            data-testid={name}
            id={name}
            onClick={onClick}
            className={`button button--profile`}
            disabled={disabled || !onClick}
        >
            <img src={UserIcon} alt="" className="profile-icon" />
            {label}
        </button>
    );
};

